const e = {
  undo: "Annuler",
  redo: "Restaurer",
  confirm: "Confirmer",
  clear: "Effacer",
  more: "Plus",
  cancel: "Annuler",
  update: "Mettre à jour"
}, r = {
  positiveText: "Confirmer",
  negativeText: "Annuler"
}, t = {
  placeholder: "Veuillez sélectionner",
  loading: "Chargement"
}, a = {
  clear: "Effacer",
  now: "Maintenant",
  confirm: "Confirmer",
  selectTime: "Sélectionner l'heure",
  selectDate: "Sélectionner la date",
  datePlaceholder: "Sélectionner la date",
  datetimePlaceholder: "Sélectionner la date et l'heure",
  monthPlaceholder: "Sélectionner un mois",
  yearPlaceholder: "Sélectionnez l'année",
  quarterPlaceholder: "Sélectionner le trimestre",
  startDatePlaceholder: "Date de début",
  endDatePlaceholder: "Date de fin",
  startDatetimePlaceholder: "Date et heure de début",
  endDatetimePlaceholder: "Date et heure de fin",
  startMonthPlaceholder: "Mois de début",
  endMonthPlaceholder: "Mois de fin",
  today: "Aujourd'hui"
}, n = {
  checkTableAll: "Sélectionner tout dans le tableau",
  uncheckTableAll: "Désélectionner tout dans le tableau",
  confirm: "Confirmer",
  clear: "Effacer",
  apply: "Appliquer",
  filters: "Filtres",
  sort: "Trier"
}, o = {
  sourceTitle: "Source",
  targetTitle: "Cible"
}, l = {
  selectAll: "Sélectionner tout",
  unselectAll: "Désélectionner tout",
  clearAll: "Effacer"
}, i = {
  description: "Aucune information"
}, c = {
  placeholder: "Veuillez sélectionner"
}, s = {
  placeholder: "Sélectionner l'heure",
  positiveText: "OK",
  negativeText: "Annuler",
  now: "Maintenant"
}, u = {
  goto: "Goto",
  selectionSuffix: "page",
  next: "Suivant",
  previous: "Précédent"
}, d = {
  add: "Ajouter"
}, m = {
  loading: "Chargement"
}, p = {
  placeholder: "Veuillez saisir"
}, f = {
  placeholder: "Veuillez saisir"
}, g = {
  create: "Créer"
}, h = {
  title: "Éditeur de thème",
  clearAllVars: "Effacer toutes les variables",
  clearSearch: "Effacer la recherche",
  filterCompName: "Nom du module du filtre",
  filterVarName: "Nom de la variable du filtre",
  import: "Importer",
  export: "Exporter",
  restore: "Rétablir les paramètres par défaut"
}, P = {
  tipPrevious: "Image précédente (←)",
  tipNext: "Image suivante (→)",
  tipCounterclockwise: "Dans le sens inverse des aiguilles d'une montre",
  tipClockwise: "Dans le sens des aiguilles d'une montre",
  tipZoomOut: "Zoom arrière",
  tipZoomIn: "Zoom avant",
  tipClose: "Fermer (Esc)",
  tipOriginalSize: "Zoom à la taille d’origine"
}, C = {
  heading: "Trier et filtrer",
  sortHeading: "Trier par",
  newestFirst: "Du plus récent au plus ancien",
  oldestFirst: "Du plus ancien au plus récent",
  ascending: "Asc",
  descending: "Descendant",
  apply: "Appliquer",
  clear: "Effacer",
  cancel: "Annuler",
  filters: "Filtres"
}, D = {
  noMatchingFound: "Aucun résultat correspondant trouvé"
}, T = {
  margin: "Marge",
  padding: "Marge interne",
  reset: "Réinitialiser",
  errorMsg: "La valeur fournie est non valide."
}, A = {
  brandColors: "Couleurs de la marque",
  noBrandColors: "Vous n'avez pas encore ajouté de couleurs à la marque.",
  getStarted: "Commencer",
  add: "Ajouter",
  default: "Par défaut"
}, S = {
  addColor: "Ajouter une nouvelle couleur",
  editColor: "Modifier la couleur",
  add: "Ajouter",
  noData: "Aucune couleur n'a encore été ajoutée.",
  invalidCode: "Code couleur non valide",
  defaultColor: "Couleurs par défaut"
}, v = {
  global: e,
  Popconfirm: r,
  Cascader: t,
  DatePicker: a,
  DataTable: n,
  LegacyTransfer: o,
  Transfer: l,
  Empty: i,
  Select: c,
  TimePicker: s,
  Pagination: u,
  DynamicTags: d,
  Log: m,
  Input: p,
  InputNumber: f,
  DynamicInput: g,
  ThemeEditor: h,
  Image: P,
  SortFilter: C,
  IconPicker: D,
  Spacing: T,
  BrandColorPicker: A,
  BrandBoard: S
};
export {
  S as BrandBoard,
  A as BrandColorPicker,
  t as Cascader,
  n as DataTable,
  a as DatePicker,
  g as DynamicInput,
  d as DynamicTags,
  i as Empty,
  D as IconPicker,
  P as Image,
  p as Input,
  f as InputNumber,
  o as LegacyTransfer,
  m as Log,
  u as Pagination,
  r as Popconfirm,
  c as Select,
  C as SortFilter,
  T as Spacing,
  h as ThemeEditor,
  s as TimePicker,
  l as Transfer,
  v as default,
  e as global
};
